import { CONFERENCE_LEFT, ENDPOINT_MESSAGE_RECEIVED } from '../base/conference/actionTypes';
import { getParticipantDisplayName } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { appendAiResponse, clearTranscripts, commitAiResponse, commitFinalTranscript, upsertInterimTranscript } from './actions';
/**
 * EndpointMessage `type` values sent by the AI (Python client) over the data
 * channel. Same transport/shape as the slide messages (PDF_SLIDE_URL, ...).
 */
export const STT_INTERIM_EVENT_TYPE = 'STT_TRANSCRIPT_INTERIM_FROM_AI';
export const STT_FINAL_EVENT_TYPE = 'STT_TRANSCRIPT_FINAL_FROM_AI';
/**
 * EndpointMessage `type` values for the AI's own responses. INTERIM chunks are
 * concatenated by generation_id; FINAL carries the full text.
 */
export const AI_RESPONSE_INTERIM_EVENT_TYPE = 'AI_RESPONSE_INTERIM_FROM_AI';
export const AI_RESPONSE_FINAL_EVENT_TYPE = 'AI_RESPONSE_FINAL_FROM_AI';
/**
 * Monotonic counter so every committed final line gets a unique React key even
 * when two arrive within the same millisecond.
 */
let _seq = 0;
/**
 * Builds a transcript line from an STT endpoint-message payload, resolving the
 * speaker name from the store when the payload didn't include one.
 *
 * @param {IStore} store - The redux store.
 * @param {any} data - The endpoint-message payload.
 * @param {boolean} final - Whether this is a FINAL (true) or INTERIM (false).
 * @returns {ITranscriptLine}
 */
function _toLine(store, data, final) {
    const participantId = String(data.participant_id ?? '');
    const name = data.participant_name
        || getParticipantDisplayName(store.getState(), participantId)
        || participantId;
    const ts = Date.now();
    return {
        id: `${participantId}-${ts}-${++_seq}`,
        participantId,
        name,
        text: String(data.text ?? ''),
        final,
        ts
    };
}
MiddlewareRegistry.register((store) => (next) => (action) => {
    if (action.type === ENDPOINT_MESSAGE_RECEIVED) {
        const { data } = action;
        if (data?.type === STT_INTERIM_EVENT_TYPE) {
            store.dispatch(upsertInterimTranscript(_toLine(store, data, false)));
        }
        else if (data?.type === STT_FINAL_EVENT_TYPE) {
            store.dispatch(commitFinalTranscript(_toLine(store, data, true)));
        }
        else if (data?.type === AI_RESPONSE_INTERIM_EVENT_TYPE) {
            store.dispatch(appendAiResponse({
                chunk: String(data.text ?? ''),
                generationId: String(data.generation_id ?? ''),
                participantId: String(data.participant_id ?? ''),
                ts: Date.now()
            }));
        }
        else if (data?.type === AI_RESPONSE_FINAL_EVENT_TYPE) {
            store.dispatch(commitAiResponse({
                generationId: String(data.generation_id ?? ''),
                participantId: String(data.participant_id ?? ''),
                text: String(data.text ?? ''),
                ts: Date.now()
            }));
        }
    }
    else if (action.type === CONFERENCE_LEFT) {
        store.dispatch(clearTranscripts());
    }
    return next(action);
});
